import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$background = this.$('background')[0];
        this.$imagesWrap = this.$('images')[0];
        this.$canvas = this.$('canvas')[0];
        this.ctx = this.$canvas.getContext('2d');
        this.backgroundColor = (typeof this.getData('background') == 'string') ? this.getData('background') : '#FCF3EA';

        this.currentImage = 0;
        this.imagesDelay = 0.5;
        this.$images = this.$('image');

        this.hasText = (typeof this.getData('text') == 'string');
        this.text = this.getData('text');
        this.textIsLoaded = false;

        if(this.hasText) {
            this.text = document.createElement('img');

            this.text.addEventListener('load', () => {
                this.textIsLoaded = true;
                this.textRatio = this.text.height / this.text.width;
            });

            this.text.src = this.getData('text');
        }
    }

    init() {
        
        this.portalRatio = 384/476;
        this.shapeWidth = 0;
        this.shapeHeight = 0;

        this.threshold = {
            value: 1
        };
        
        this.firstHit = true;
        this.resize();
        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);

        this.imagesTl = gsap.timeline();
        this.imagesTl.pause();
        this.imagesTl.fromTo(this.$imagesWrap, {
            scale: 0
        },
        {
            scale: 1,
            ease: "power2.inOut"
        });
        this.imagesInnerTl = gsap.timeline();
        this.imagesInnerTl.pause();
        this.imagesInnerTl.fromTo(this.$images, {
            scale: 1.8
        },
        {
            scale: 1,
            ease: "power2.inOut"
        });
    }

    trigger(e) {
        if(e.mode == 'enter') {

            if(this.firstHit) {
                this.firstHit = false;
                this.el.classList.add('is-visible');
            }
            this.draw();
            this.stopImages();
            this.nextImage();
        } else {
            this.stopImages();
            cancelAnimationFrame(this.raf);
        }
    }

    progress({progress, isReversed}) {
        let relativeProgress = progress;
        
        if(this.tl != undefined) {
            this.tl.progress(relativeProgress);
            this.backgroundTl.progress(relativeProgress);
            this.imagesTl.progress(-0.3 + relativeProgress * 1.3);
            this.imagesInnerTl.progress(-0.3 + relativeProgress * 1.3);
        }
    }

    draw(once = false) {

        this.ctx.globalCompositeOperation='source-over';
        this.ctx.fillStyle = this.backgroundColor;
        this.ctx.fillRect(0,0,this.w, this.h);


        if(this.textIsLoaded) {
            this.textWidth = this.shapeWidth * 1.4;
            this.textHeight = this.textWidth * this.textRatio;
            this.ctx.drawImage(this.text, this.w/2 - this.textWidth/2, this.h/2 - this.textHeight/1.7, this.textWidth, this.textHeight);
        }

        this.ctx.globalCompositeOperation='destination-out';

        this.shapeWidthThreshold = this.shapeWidth * this.threshold.value;
        this.shapeHeightThreshold = this.shapeHeight * this.threshold.value;
        this.ctx.beginPath();
        this.ctx.fillStyle = 'red';
        this.ctx.arc(this.w/2, this.h/2, this.shapeWidthThreshold/2, Math.PI, 0);
        this.ctx.rect(this.w/2 - (this.shapeWidthThreshold/2), this.h/2, this.shapeWidthThreshold, this.shapeHeightThreshold/1.8);
        this.ctx.fill();
        this.ctx.closePath();

        if(!this.firstHit) {
            this.raf = requestAnimationFrame(() => this.draw());
        }
    }

    nextImage() {
        
        this.$images.forEach((image, index) => {
            if(index == this.currentImage) {
                image.classList.add('is-active');
            } else {
                image.classList.remove('is-active');
            }
        });

        if(this.currentImage < this.$images.length - 1) {
            this.currentImage++;
        } else {
            this.currentImage = 0;
        }

        this.delayedCallImages = gsap.delayedCall(this.imagesDelay, () => {
            this.nextImage();
        });
    }
    
    stopImages() {

        if(this.delayedCallImages != undefined) {
            this.delayedCallImages.kill();
        }
    }

    
    resize() {
        if(this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

    resizeDebounce() {
        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.$canvas.width = this.w;
        this.$canvas.height = this.h;
        this.$canvas.style.width = this.w;
        this.$canvas.style.height = this.h;

        if(this.w/this.h > this.portalRatio) {
            this.shapeHeight = this.h/2;
            this.shapeWidth = this.shapeHeight * this.portalRatio;

            this.tl = new gsap.timeline();
            this.tl.pause();
            this.tl.fromTo(this.threshold,{
                value: 1,
            }, {
                value: this.w*1.2 / this.shapeWidth,
                ease: "power1.inOut"
            });

            this.backgroundTl = gsap.timeline();
            this.backgroundTl.pause();
            this.backgroundTl.fromTo(this.$background, {
                scale: this.shapeHeight * 2 / this.h
            },
            {
                scale: 1.2,
                ease: "power1.inOut"
            });

        } else{
            this.shapeWidth = this.w/2;
            this.shapeHeight = this.shapeWidth * (1/this.portalRatio);

            this.tl = new gsap.timeline();
            this.tl.pause();
            this.tl.fromTo(this.threshold,{
                value: 1,
            }, {
                value: this.h*1.2 / this.shapeHeight,
                ease: "power1.inOut"
            });

            this.backgroundTl = gsap.timeline();
            this.backgroundTl.pause();
            this.backgroundTl.fromTo(this.$background, {
                scale: this.shapeWidth * 2 / this.w
            },
            {
                scale: 1.2,
                ease: "power1.inOut"
            });
        }
    }

    destroy() {
        cancelAnimationFrame(this.raf);
        window.removeEventListener('resize', this.bindResize);
    }
}
